import * as React from "react";
import { useMachine } from "@xstate/react";
import { Button, Loader, Separator, Text } from "@nju/ui";
import { verificationDataMachine } from "./verificationData.machine";

interface IVerificationDataProps {
  userId: string | undefined;
}

export function VerificationData({ userId }: IVerificationDataProps) {
  const [current, send] = useMachine(verificationDataMachine, {
    context: {
      userId,
    },
  });

  const { context } = current;
  const { userDigits } = context;

  const handleFetchUserDigits = React.useCallback(() => {
    return send({ type: "FETCH_USER_DIGITS" });
  }, [send]);

  return (
    <>
      <Separator size="xs" tone="invisible" />
      <Text testId="dev-tip-verification-data">
        DevTip User Digits: {current.matches("loading") && <Loader />}
        {userDigits && !current.matches("loading") && userDigits}
      </Text>
      <Button
        onPress={() => {
          return handleFetchUserDigits();
        }}
        size="inline"
        testId="dev-tip-sim-number-button"
        variant="simple"
        withUnderline={true}
      >
        Dane użytkownika
      </Button>
    </>
  );
}
